"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const emailVerificationStates_1 = require("./emailVerificationStates");
const react_hook_form_1 = require("react-hook-form");
const react_countdown_1 = __importStar(require("react-countdown"));
const react_number_format_1 = __importDefault(require("react-number-format"));
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const react_lottie_player_1 = __importDefault(require("react-lottie-player"));
const _1 = require(".");
function default_1({ emailVerificationForm, sendVerificationEmail, apiMidPath, }) {
    const { watch, setError, control } = emailVerificationForm;
    const email = watch('email');
    const [isEmailVerified, setIsEmailVerified] = (0, recoil_1.useRecoilState)(emailVerificationStates_1.isEmailVerifiedState);
    const emailVerifyTimeLimit = (0, recoil_1.useRecoilValue)(emailVerificationStates_1.emailVerifyTimeLimitState);
    const resetEmailVerifyTimeLimit = (0, recoil_1.useResetRecoilState)(emailVerificationStates_1.emailVerifyTimeLimitState);
    const checkEmailVerification = (codeInput) => __awaiter(this, void 0, void 0, function* () {
        yield (0, api_1.postData)(`/api/v1/${apiMidPath}/verify-email`, { email, auth_code: codeInput })
            .then(() => {
            setIsEmailVerified(true);
            resetEmailVerifyTimeLimit();
        })
            .catch(error => (0, _1.handleEmailVerificationError)(error, setError));
    });
    const verificationTimerRef = (0, react_1.useRef)(0);
    const onVeriCodeInputChange = (codeInput) => {
        window.clearTimeout(verificationTimerRef.current);
        if (codeInput.length === 6) {
            verificationTimerRef.current = window.setTimeout(() => checkEmailVerification(codeInput), 500);
        }
    };
    const { field: { ref, onChange, value }, } = (0, react_hook_form_1.useController)({
        name: 'veriCode',
        control: control,
    });
    const isEmailApproved = isEmailVerified === true;
    const isEmailVerifiable = Boolean(emailVerifyTimeLimit);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(_1.EmailVerificationInputDiv, Object.assign({ css: { marginTop: '6px' } }, { children: [(0, jsx_runtime_1.jsx)(react_number_format_1.default, { disabled: isEmailApproved, value: value, getInputRef: ref, allowLeadingZeros: true, allowNegative: false, decimalScale: 0, onValueChange: e => {
                    if (isEmailVerifiable) {
                        onChange(e.value);
                        onVeriCodeInputChange(e.value);
                    }
                }, maxLength: 6, placeholder: t('인증번호'), pattern: "\\d*" }), isEmailVerified === 'proceeding' && ((0, jsx_runtime_1.jsx)(_1.BlackAuthButton, Object.assign({ onClick: sendVerificationEmail }, { children: t('재발송') }))), isEmailVerifiable && ((0, jsx_runtime_1.jsx)(react_countdown_1.default, { date: emailVerifyTimeLimit, renderer: ({ minutes, seconds }) => ((0, jsx_runtime_1.jsx)("span", Object.assign({ css: {
                        position: 'absolute',
                        right: '78px',
                        fontSize: '15px',
                        color: 'var(--primary-dark)',
                    } }, { children: `${(0, react_countdown_1.zeroPad)(minutes)}:${(0, react_countdown_1.zeroPad)(seconds)}` }))), onComplete: () => {
                    resetEmailVerifyTimeLimit();
                    setError('veriCode', { type: '40001', message: _1.emailVeriErrMsgObj.expired() });
                } })), isEmailApproved && ((0, jsx_runtime_1.jsx)(react_lottie_player_1.default, { path: `${process.env.CDN_URL}/assets/animations/email_check.json`, play: true, loop: false, css: { position: 'absolute', right: '14px', width: '24px', height: '24px' } }))] })));
}
exports.default = default_1;
